import { TransferSpecificProductDetails } from "../types/core"

export const extractProductFields = (
  productsForDocument: TransferSpecificProductDetails[],
) => {
  return {
    descriptions: productsForDocument.map((p) => p?.description).filter(Boolean) as string[],
    net_weights: productsForDocument.map((p) => p?.net_weight).filter(Boolean) as string[],
    net_volumes: productsForDocument.map((p) => p?.net_volume).filter(Boolean) as string[],
    container_numbers: productsForDocument.map((p) => p?.container_number).filter(Boolean) as string[],
    NZHSC_codes: productsForDocument.map((p) => p?.NZHSC_code).filter(Boolean) as string[],
    sub_class: productsForDocument.map((p) => p?.sub_class).filter(Boolean) as string[],
    class: productsForDocument.map((p) => p?.class).filter(Boolean) as string[],
    botanical_name: productsForDocument.map((p) => p?.botanical_name).filter(Boolean) as string[],
    eligibility_countries: productsForDocument.flatMap((p) => p?.eligibility_countries || []).filter(Boolean) as string[],
    seals: productsForDocument.flatMap((p) => p?.seals || []).filter(Boolean) as string[],
    production_batch_ids: productsForDocument.flatMap((p) => p?.productionBatch_ids || []).filter(Boolean) as string[],
    item_marks: productsForDocument.flatMap((p) => p?.item_marks || []).filter(Boolean) as string[],
    unofficial_commercial_ref: productsForDocument.map((p) => p?.unofficial_commercial_ref).filter(Boolean) as string[],
    unofficial_commercial_info: productsForDocument.map((p) => p?.unofficial_commercial_info).filter(Boolean) as string[],
  }
}
